import { QueryKey, useQueryClient } from "react-query";

export const AccessTokenQueryKey = 'access_token__query_key'

export const StorageTokenKeys = 'storage_token_keys'

export const UserPhoneQueryKey = 'user_phone_query_key'

export const RegisterResQueryKey = 'register_res_query_key'

export const useConfig = (
  queryKey: QueryKey,
  callback: (target: any, old?: any[]) => any[]
) => {
  const queryClient = useQueryClient();
  return {
    onSuccess: () => queryClient.invalidateQueries(queryKey),
    async onMutate(target: any) {
      const previousItems = queryClient.getQueryData(queryKey);
      queryClient.setQueryData(queryKey, (old?: any[]) => {
        return callback(target, old);
      });
      return { previousItems };
    }
  };
};

export const useVerifyPhone = (queryKey: QueryKey) =>
  useConfig(queryKey, (target) => {
    return target;
  });